import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { PiLockKeyBold } from "react-icons/pi";
import { UserContext } from "../../context/UserContext";
import { UserSpecialHasLimits } from "../../functions/permission";

const SubscriptionGate = ({ children }) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const previewRef = useRef(null);

  // Disable all interaction inside the preview at the DOM level (not via CSS),
  // so the section stays unusable even if the styling class is removed by hand.
  // `inert` only blocks user input/focus - effects and auto data loading still run.
  useEffect(() => {
    if (previewRef.current) {
      previewRef.current.inert = true;
    }
  });

  if (!UserSpecialHasLimits(user)) {
    return children;
  }

  return (
    <div className="subscription-locked" style={{ position: "relative" }}>
      <div
        ref={previewRef}
        className="subscription-locked-preview"
        aria-hidden="true"
      >
        {children}
      </div>
      <div
        className="subscription-locked-overlay"
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 30,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => navigate("/panel/platnosci")}
      >
        <div className="subscription-locked-message">
          <PiLockKeyBold />
          <span>Funkcja dostępna w płatnej subskrypcji</span>
          <small>Kliknij, aby wykupić subskrypcję</small>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionGate;
